import styled from "styled-components";
import { size } from "styled-theme";
import ContentWrapper from "@components/contentWrapper";
import { CheckMarkSvg } from "@components/checkMark/checkMark.styles";

const Wrapper = styled(ContentWrapper).attrs(() => ({
  as: "main"
}))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
  color: black;
  text-align: center;
  
  ${CheckMarkSvg} {
    align-self: center;
    padding-bottom: 40px;
  }
  
  @media only screen and (min-width: ${size("M")}) {
    min-height: 65vh;
    margin-top: 64px;
  }
`;

export default Wrapper;